export function hasVsmAccess(features) {
  const f = features || {}
  return !!(
    f.vehicle_status_management_enabled ||
    f.vehicle_status_management_dvir_enabled ||
    f.vehicle_status_management_maint_enabled
  )
}

export function hasVsmHistoryAccess(user) {
  if (!user) return false
  if (user.role === 'garage' || user.role === 'wash-bay') return false
  const features = (user.features && user.features[user.tenant]) || {}
  return !!features.vehicle_status_management_enabled
}

export function vsmRouteName(tenantType, features) {
  if (!hasVsmAccess(features)) return 'vehstatusmgr'

  const f = features || {}
  if (tenantType === 'TBN') {
    if (f.vehicle_status_management_dvir_enabled) return 'vehicle_status_dvir_tbn'
    if (f.vehicle_status_management_maint_enabled) return 'vehicle_status_maint_tbn'
    return 'vehicle_status_tbn'
  }
  if (f.vehicle_status_management_maint_enabled) return 'vehicle_status_maint'
  if (f.vehicle_status_management_dvir_enabled) return 'vehicle_status_dvir'
  return 'vehicle_status'
}

// FI-2156: the board component a tenant's VSM link actually lands on. Same
// resolution as vsmRouteName plus the fasttrak hardcode the navbar has always
// applied with no feature check. Setup reads it to seed a Customize Columns
// modal from the board the tenant opens, and nav/registry.js routes from it,
// so the two cannot disagree about which board that is.
export function vsmBoardRouteName(tenantType, features) {
  if (tenantType === 'FASTTRAK') return 'vehicle_status_dvir_fasttrak'
  return vsmRouteName(tenantType, features)
}

// FI-2133: which backend serves this tenant's VSM board. the boards all render
// the same {summary, results} contract; only the read endpoint differs by
// booking source. mirrors vsm_board.vue's vsmSource computed so the legacy
// boards and the shared board never disagree about where data comes from.
export function vsmSourceFor(tenantType) {
  if (tenantType === 'FASTTRAK') return 'fasttrak'
  if (tenantType === 'TBN') return 'tbn'
  if (tenantType === 'MOOVS') return 'moovs'
  return 'cm'
}
